import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import DocumentGrantedUsers from "./document-granted-users";
import { useDocumentContent } from "../../hooks";
import { DownCircleOutlined } from "@ant-design/icons";
import { arrayNest, IDocument, IDocumentContent, Role, UserPermission } from "./document-view-decentralize";
import { html } from "../../utils/html";
import { useUser } from "../../../../hook";

interface Props {
  document?: IDocument;
}

type DataType = IDocumentContent & { children?: IDocumentContent[] };

const DocumentDecentralizePreview = (props: Props) => {
  const { isLoading: isDocumentContentLoading, data: documents = [] } = useDocumentContent();
  const { email, checkCurrentUser } = useUser();

  const checkHasPermission = (userPermissions: UserPermission[], currentEmail: string): boolean => {
    return userPermissions.some((item) => checkCurrentUser(item.user.email));
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Nội dung",
      dataIndex: "Content",
      key: "Content",
      render: (value: string, document) => {
        const hasPermission = checkHasPermission(document?.UserPermissions ?? [], email);
        const isCreatedUser = checkCurrentUser(document.CreatedUser.email);

        if (!document.IsContent || hasPermission || isCreatedUser) {
          const doc = html.htmlStringToObject(value);
          const tree = html.getTreeData(doc);
          const htmlString = html.objectToHtmlString(tree);
          return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
        }
        return null;
      },
    },
    {
      title: "Danh sách người xem",
      dataIndex: "UserPermissions",
      key: "readUsers",
      width: "400px",
      render: (users) => <DocumentGrantedUsers closable={false} roles={[Role.read]} userPermissions={users} />,
    },
    {
      title: "Danh sách người chỉnh sửa",
      dataIndex: "UserPermissions",
      width: "400px",
      key: "editUsers",
      render: (users) => <DocumentGrantedUsers closable={false} roles={[Role.update]} userPermissions={users} />,
    },
  ];

  const mappedDocuments = arrayNest<IDocumentContent>(documents, {
    idFieldName: "CustomId",
    parentIdFieldName: "CustomParentId",
  });

  const loading = isDocumentContentLoading;

  return (
    <Table
      rowKey="Id"
      loading={loading}
      bordered
      className="ant-table-row-actions-disabled"
      columns={columns}
      dataSource={mappedDocuments}
      pagination={false}
      scroll={{ x: 1600 }}
      expandable={{
        defaultExpandAllRows: true,
        expandIcon: ({ expanded, onExpand, record }) => {
          if (record.children?.length === 0) return null;
          return (
            <DownCircleOutlined
              rotate={expanded ? 0 : 180}
              style={{ fontSize: 20 }}
              rev="data"
              onClick={(e) => onExpand(record, e)}
            />
          );
        },
      }}
    />
  );
};

export default DocumentDecentralizePreview;
